import Form from './DoctorForm';
import React, { Component } from 'react';
import LoadMask from 'Utils/LoadMask/LoadMask';


export default class DoctorCrear extends Component {

    state = {
        editar: false,
        mensaje: 'Agregar Doctor',
        password: false,
    }

    componentWillMount(){
        const {
            createInitialize
        } = this.props;

        createInitialize();

        if(this.props.match.params.id){
            this.props.detail(this.props.match.params.id);
            this.setState({
                    editar: true,
                    mensaje: 'Editar referente'
                });
        }
    }

    render() {

        const {
            create,
            update
        } = this.props;

        const {
            updateData,
            cargando
        } = this.props;

        return (
            <div className="content">
                <div className="m-auto row-fluid big-card-form">
                    <div className="table-decoration">
                        <LoadMask loading={cargando} blur_1>
                            {
                                this.state.editar ?
                                    <div className="fields">
                                        <div className="top-title">
                                            DOCTOR
                                        </div>
                                        <Form
                                        onSubmit={update}
                                        updateData={updateData}
                                        editando={true} />
                                    </div>
                            :
                                <div className="fields">
                                    <div className="top-title">
                                        CREAR DOCTOR
                                    </div>
                                    <Form onSubmit={create}/>
                                </div>
                            }
                        </LoadMask>
                    </div>
                </div>
            </div>
        )
    }
}
